import "babel-polyfill";

import "backbone.marionette";
import "backbone.radio";
import "backbone.syphon";
import "bootstrap";
import moment from "moment";

import "../../utils/window";
import environment from "../../common/environment";
import { detectIE } from "../../utils";

import LoadingIndicator from "../../views/generic/loading-indicator";
import App from "./app";

/**
 * Marionette shim needed until the library is updated to 3.0.0, which will
 * include Radio natively.
 *
 * See https://github.com/marionettejs/backbone.radio and
 * http://benmccormick.org/2015/01/26/backbone-radio/
 */
(function (root, factory) {
  module.exports = factory(
    require("backbone.marionette"),
    require("backbone.radio"),
    require("underscore")
  );
})(this, (Marionette, Radio) => {
  Marionette.Application.prototype._initChannel = function () {
    this.channelName = this.channelName ? this.channelName : "global";
    this.channel = this.channel
      ? this.channel
      : Radio.channel(this.channelName);
  };
});

// app initializer
const init = () => {
  new LoadingIndicator();

  // store target location. typically the complete URL the user intended to
  // visit prior to authentication
  RVC.targetLocation = Object.assign({}, window.location);

  // detect IE
  try {
    RVC.internetExplorerVersion = detectIE();
  } catch (err) {
    RVC.internetExplorerVersion = 999;
  }

  if (
    _.isNumber(RVC.internetExplorerVersion) &&
    RVC.internetExplorerVersion < 11
  ) {
    location.assign = `${environment.getAppHost()}/unsupported-browser`;
  }

  /**
   * Override default Syphon checkbox handling logic to only return checked
   * items.
   *
   * This results in the removal of unchecked properties from the seralized
   * form values object.
   */
  Backbone.Syphon.KeyAssignmentValidators.register(
    "checkbox",
    ($el, key, checked) => checked
  );

  // export moment to window scope.
  // This is necessary for the KendoUI template system.
  window.moment = moment;

  // finally, instantiate and start the application
  new App().start();
};

$(document).ready(init);
